import { render, staticRenderFns } from "./DataSourceTemplateList.vue?vue&type=template&id=13db6116&"
import script from "./DataSourceTemplateList.vue?vue&type=script&lang=ts&"
export * from "./DataSourceTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports